import "./style.css";

const PrivacyPage = () => {
	return (
		<div className="privacy-page" id="Privacy">
			<div className="container">
				<p className="title">Privacy Policy </p>
				<p className="description">
					Padelink is an all-in-one platform designed for padel enthusiasts. It
					allows users to book or create matches and tournaments of various
					types, and easily invite friends to join. The app also offers a chat
					feature for player interaction, along with a dedicated marketplace for
					buying and selling new and used padel products such as rackets, balls,
					and other equipment. Padelink aims to bring the padel community
					together in one place, combining play, interaction, and commerce in a
					smooth and enjoyable experience.
				</p>
			</div>
		</div>
	);
};
export default PrivacyPage;
